import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5295_802" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="2" y="3" width="20" height="16">
        <path
          d="M21.5898 18.71H2.25L9.58984 11.5596L11.9199 13.8203L14.25 11.5596L21.5898 18.71ZM8.75977 10.75L2.07031 16.9297L2 4.15039L8.75977 10.75ZM21.4199 16.9297L15.21 10.6201L21.4902 4.49023L21.4199 16.9297ZM21.5898 3L11.9199 12.4297L2.25 3H21.5898Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_5295_802)">
        <rect x="2" y="1" width="20" height="20" fill="#006BC2" />
      </g>
    </svg>
  );
};

export default Icon;
